import { render, staticRenderFns } from "./DefiLock.vue?vue&type=template&id=2ad6a242&"
import script from "./DefiLock.vue?vue&type=script&lang=js&"
export * from "./DefiLock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports